import { ReactElement, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Grid, LinearProgress } from '@mui/material';
import AutheLayoutLeftPanel from './components/AutheLayoutLeftPanel';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './components/AADProvider';

const AuthenticationWrapper = (): ReactElement => (
  <MsalProvider instance={msalInstance}>
    <Grid container component="main" className="auth-wrapper">
      <Grid item xs={12} sm={6} md={7}>
        <AutheLayoutLeftPanel />
      </Grid>
      <Grid item xs={12} sm={6} md={5} className="right-panel h-100">
        <Suspense fallback={<LinearProgress color="primary" />}>
          <Outlet />
        </Suspense>
      </Grid>
    </Grid>
  </MsalProvider>
);

export default AuthenticationWrapper;
